export default __webpack_public_path__ + "static/media/FAQ-Marathon-48h-du-Court-Metrage-d-Haloween.910dde1a.pdf";